/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
  ActivityIndicator,
} from 'react-native';
// eslint-disable-next-line no-unused-vars
import { useDispatch, useSelector } from 'react-redux';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useFormikContext } from 'formik';
import * as Linking from 'expo-linking';

import { Loader } from '@components/screen/Layout';
import SociollaText from '@components/sociolla/SociollaText';
import Button from '@components/form/Button';
import WebViews from '@/plugins/webview';
import Image from '@components/global/Image';
import SelectBox from '@components/form/SelectBox';
import ModalFull from '@components/modal/ModalFull';
import { translate } from '@global/translate';

import useLocation from '@/hooks/useLocation';
import { formControlContainer } from '@assets/styles/formStyles';
import FormLabel from '@components/form/common/FormLabel';
import {
  googleMapsAutocomplete,
  googleMapsGeocode,
  googleMapsPlaceDetail,
} from '@api/ms-account';
import { isWeb, isNative } from '@global/screens';
import Colors from '@global/colors';
import { showPopup } from '@/store/modal';
import { buttonFloating, buttonRounded } from '@/assets/styles/buttonStyles';
import {
  generateGMapsLink,
  getGoogleMapKey,
  getMapWebViewBaseUrl,
} from '@global/helpers';

const dimension = Dimensions.get('window');

function SociollaGoogleMaps(props) {
  const {
    value,
    disabled = false,
    editable = true,
    hideInput = false,
    label,
    height = 220,
    containerStyle = {},
    // eslint-disable-next-line no-unused-vars
    mapContainerStyle = {},
    onChange,
    onCurrentLocation,
    onChangeAddress,
  } = props;
  const webViewRef = useRef();
  const currentLocation = useLocation();
  const dispatch = useDispatch();

  let form = null;
  if (editable) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    form = useFormikContext();
  }

  const insets = useSafeAreaInsets();
  const screenHeight = isWeb
    ? 'auto'
    : dimension.height - insets.top - insets.bottom;
  // eslint-disable-next-line no-unused-vars

  const [place, setPlace] = useState('');
  const [loc, setLoc] = useState('');
  const [html, setHtml] = useState('');
  const [modalHtml, setModalHtml] = useState('');
  const [modal, setModal] = useState(false);
  const [noLocation, setNoLocation] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);

  function getMapScript(
    location,
    disabled,
    zoom = 16,
    currentLocation,
    isModal = false,
  ) {
    const curr = {
      latitude:
        currentLocation && currentLocation.latitude
          ? currentLocation.latitude
          : '',
      longitude:
        currentLocation && currentLocation.longitude
          ? currentLocation.longitude
          : '',
    };
    const loc = {
      lat: location.lat || -6.187755,
      lng: location.lng || 106.7387891,
    };

    let map = null;
    if (!isNative) {
      const getLocationDetail = (geocoder, pos) => {
        // loaderElm.style.display = 'flex';
        const position = pos;
        geocoder
          .geocode({ location: position })
          .then((response) => {
            if (response.results[0]) {
              position.address = response.results[0].formatted_address;
              // loaderElm.style.display = 'none';
              const payloadStr = JSON.stringify(position);
              getLocation({
                data: payloadStr,
              });
            } else {
              window.alert(translate('No results found'));
            }
          })
          .catch((e) =>
            window.alert(translate('Geocoder failed due to: ') + e),
          );
      };

      const addYourLocationButton = (map, marker, geocoder, current) => {
        if (current.latitude && current.longitude) {
          const controlDiv = document.createElement('div');

          const firstChild = document.createElement('button');
          firstChild.style.backgroundColor = '#fff';
          firstChild.style.border = 'none';
          firstChild.style.outline = 'none';
          firstChild.style.width = '28px';
          firstChild.style.height = '28px';
          firstChild.style.borderRadius = '2px';
          firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
          firstChild.style.cursor = 'pointer';
          firstChild.style.marginRight = '10px';
          firstChild.style.padding = '0px';
          firstChild.title = 'Your Location';
          controlDiv.appendChild(firstChild);

          const secondChild = document.createElement('div');
          secondChild.style.margin = '5px';
          secondChild.style.width = '18px';
          secondChild.style.height = '18px';
          secondChild.style.backgroundImage =
            'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)';
          secondChild.style.backgroundSize = '180px 18px';
          secondChild.style.backgroundPosition = '0px 0px';
          secondChild.style.backgroundRepeat = 'no-repeat';
          secondChild.id = 'img-location';
          firstChild.appendChild(secondChild);

          window.google.maps.event.addListener(map, 'dragend', function () {
            document.getElementById('img-location').style.backgroundPosition =
              '0px 0px';
          });

          firstChild.addEventListener('click', function () {
            let imgX = '0';
            const animationInterval = setInterval(function () {
              if (imgX == '-18') {
                imgX = '0';
              } else {
                imgX = '-18';
              }
              document.getElementById('img-location').style.backgroundPosition =
                imgX + 'px 0px';
            }, 500);
            const latlng = new window.google.maps.LatLng(
              current.latitude,
              current.longitude,
            );
            marker.setPosition(latlng);
            map.setCenter(latlng);
            clearInterval(animationInterval);
            document.getElementById('img-location').style.backgroundPosition =
              '-144px 0px';
            getLocationDetail(geocoder, {
              lat: current.latitude,
              lng: current.longitude,
            });
          });

          controlDiv.index = 1;
          map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(
            controlDiv,
          );
        }
      };

      if (!isModal) {
        // Handle current location map
        map = new window.google.maps.Map(
          document.getElementById('nina-google-maps'),
          {
            zoom: zoom,
            center: loc,
            draggable: !disabled,
            zoomControl: !disabled,
            scrollwheel: !disabled,
            disableDoubleClickZoom: disabled,
            disableDefaultUI: disabled,
            streetViewControl: false,
            rotateControl: false,
            mapTypeControl: false,
          },
        );
      } else {
        // Handle find location map
        map = new window.google.maps.Map(
          document.getElementById('nina-google-maps-modal'),
          {
            zoom: zoom,
            center: loc,
            draggable: !disabled,
            zoomControl: !disabled,
            scrollwheel: !disabled,
            disableDoubleClickZoom: disabled,
            disableDefaultUI: disabled,
            streetViewControl: false,
            rotateControl: false,
            mapTypeControl: false,
          },
        );
      }

      const marker = new window.google.maps.Marker({
        position: loc,
        map: map,
        draggable: !disabled,
      });

      const geocoder = new window.google.maps.Geocoder();
      marker.addListener('dragend', (event) => {
        const position = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };
        getLocationDetail(geocoder, position);
      });

      if (curr.latitude && curr.longitude && !disabled) {
        addYourLocationButton(map, marker, geocoder, curr);
      }

      return new Date().toISOString();
    }

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Sociolla Map Picker</title>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
          #spinner-container {
            width: 100vw;
            height: 100vh;
            background: rgb(84 75 75 / 25%);
            position: absolute;
            top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .spinner {
            border: 10px solid #f3f3f3;
            border-radius: 50%;
            border-top: 10px solid #3498db;
            width: 40px;
            height: 40px;
            -webkit-animation: spin 2s linear infinite;
            animation: spin 2s linear infinite;
          }
          /* Safari */
          @-webkit-keyframes spin {
            0% { -webkit-transform: rotate(0deg); }
            100% { -webkit-transform: rotate(360deg); }
          }
          
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          #search-container {
            position: absolute;
            top: 10px;
            left: 10px;
            background: #fff;
            border-radius: 8px;
            box-sizing: border-box;
            width: 250px;
            height: 35px;
            border-bottom: 1px solid transparent;
            padding: 5px 65px 0px 12px;
            box-shadow: 0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0 rgb(0 0 0 / 2%);
          }
          #search-input-gmaps {
            font-size: 15px;
            padding: 0!important;
            height: 24px!important;
            line-height: 24px;
            vertical-align: top;
            border: none;
            outline: none;
            padding: 0 10px;
            top: 10px !important;
            left: 10px !important;
            padding: 5px 10px !important;
            width: 75%;
            border-radius: 4px;
            box-shadow: 0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0 rgb(0 0 0 / 2%);
          }
  
          #search-input {
            width: 100%;
            font-size: 15px;
            padding: 0!important;
            height: 24px!important;
            line-height: 24px;
            vertical-align: top;
            border: none;
            outline: none;
          }
            
          #search-button {
            position: absolute;
            right: 0;
            top: 0;
            background: #4683ea;
            color: #ffffff;
            border: 0;
            border-radius: 0;
            margin: 0;
            outline: 0;
            vertical-align: baseline;
            height: 35px;
            padding: 0 15px;
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
            cursor: pointer;
          }
        </style>
        <script>
          let map = null;
          let marker = null;
          let newMarkerPosition = null;
          var current = ${JSON.stringify(curr)};
          var curLocation = ${JSON.stringify(loc)};
          // let sessionToken = null;
          // const buttonSearch = document.getElementById("search-button");
          // const inputSearch = document.getElementById("search-input");
          // const inputSearchGmaps = document.getElementById("search-input-gmaps");
          // Initialize and add the map
          window.initMap = function initMap() {
            // inputSearchGmaps.style.display = ${disabled} ? 'none' : 'block';
            map = new google.maps.Map(document.getElementById("map"), {
              zoom: ${zoom},
              center: curLocation,
              draggable: ${!disabled},
              zoomControl: ${!disabled},
              scrollwheel: ${!disabled},
              disableDoubleClickZoom: ${disabled},
              disableDefaultUI: ${disabled},
              streetViewControl: false,
              rotateControl: false,
              mapTypeControl: false
            });
            marker = new google.maps.Marker({
              position: curLocation,
              map: map,
              draggable: ${!disabled}
            });
            const geocoder = new google.maps.Geocoder();
            const loaderElm = document.getElementById("spinner-container");
            marker.addListener('dragend', (event) => {
              const position = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
              };
              getLocationDetail(geocoder, position, loaderElm);
              //handleEvent(event, geocoder, loaderElm)
            });
            // const searchBox = new google.maps.places.SearchBox(input);
  
            // var searchBox = new google.maps.places.SearchBox(inputSearchGmaps);
            // map.controls[google.maps.ControlPosition.TOP_LEFT].push(inputSearchGmaps);
            //   map.addListener('bounds_changed', function() {
            //   searchBox.setBounds(map.getBounds());
            // });
  
            // var markers = [];
            // searchBox.addListener('places_changed', function() {
            // 	var places = searchBox.getPlaces();
            // 	if (places.length == 0) {
            // 		return;
            // 	}
            // 	markers.forEach(function(marker) {
            // 		marker.setMap(null);
            // 	});
            // 	markers = [];
            // 	var bounds = new google.maps.LatLngBounds();
            // 	places.forEach(function(place) {
            // 		if (!place.geometry) {
            // 			console.log("Returned place contains no geometry");
            // 			return;
            // 		}
            //     const position = {
            //       address: place.formatted_address,
            //       lat: place.geometry.location.lat(),
            //       lng: place.geometry.location.lng()
            //     };
            //     setData(position);
            // 		markers.push(new google.maps.Marker({
            // 			map: map,
            // 			position: place.geometry.location
            // 		}));
  
            // 		if (place.geometry.viewport) {
            // 			bounds.union(place.geometry.viewport);
            // 		} else {
            // 			bounds.extend(place.geometry.location);
            // 		}
            // 	});
            // 	map.fitBounds(bounds);
            //   map.setZoom(${zoom});
            // });
  
            // inputSearchGmaps.style.display = ${disabled} ? 'none' : 'block';
            // sessionToken = new google.maps.places.AutocompleteSessionToken();
  
            if (current.latitude && current.longitude && ${!disabled}) {
              addYourLocationButton(map, marker, geocoder, loaderElm, current);
            }
          }
  
          function addYourLocationButton(map, marker, geocoder, loaderElm, current) {
              if (current.latitude && current.longitude) {
                var controlDiv = document.createElement('div');
  
                var firstChild = document.createElement('button');
                firstChild.style.backgroundColor = '#fff';
                firstChild.style.border = 'none';
                firstChild.style.outline = 'none';
                firstChild.style.width = '28px';
                firstChild.style.height = '28px';
                firstChild.style.borderRadius = '2px';
                firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
                firstChild.style.cursor = 'pointer';
                firstChild.style.marginRight = '10px';
                firstChild.style.padding = '0px';
                firstChild.title = 'Your Location';
                controlDiv.appendChild(firstChild);
  
                var secondChild = document.createElement('div');
                secondChild.style.margin = '5px';
                secondChild.style.width = '18px';
                secondChild.style.height = '18px';
                secondChild.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)';
                secondChild.style.backgroundSize = '180px 18px';
                secondChild.style.backgroundPosition = '0px 0px';
                secondChild.style.backgroundRepeat = 'no-repeat';
                secondChild.id = 'img-location';
                firstChild.appendChild(secondChild);
  
                google.maps.event.addListener(map, 'dragend', function() {
                  document.getElementById('img-location').style.backgroundPosition = '0px 0px';
                });
  
                firstChild.addEventListener('click', function() {
                    var imgX = '0';
                    var animationInterval = setInterval(function(){
                        if(imgX == '-18') imgX = '0';
                        else imgX = '-18';
                        document.getElementById('img-location').style.backgroundPosition = imgX+'px 0px';
                    }, 500);
                    var latlng = new google.maps.LatLng(current.latitude, current.longitude);
                    marker.setPosition(latlng);
                    map.setCenter(latlng);
                    clearInterval(animationInterval);
                    document.getElementById('img-location').style.backgroundPosition = '-144px 0px';
                    getLocationDetail(geocoder, { lat: current.latitude, lng:current.longitude}, loaderElm);
                });
  
                controlDiv.index = 1;
                map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
              }
          }
  
          // buttonSearch.addEventListener('click', () => {
          //  	if (inputSearch.value && inputSearch.value.length > 4 && sessionToken) {
          //  		let autocompleteService = new google.maps.places.AutocompleteService();
          //  		autocompleteService.getPlacePredictions({
          //  			input: inputSearch.value,
          //  			sessionToken: sessionToken
          //  			}, predictions => {
          //  				console.log('result :: ', predictions);
          //  			});
          //  	} else {
          //  		window.alert("Minimal 5 karakter");
          //  	}
          // });
  
          // Event dragend
          function handleEvent(event, geocoder, loaderElm) {
            loaderElm.style.display = "flex";
            const position = {
              lat: event.latLng.lat(),
              lng: event.latLng.lng()
            }
            geocoder.geocode({ location: position }).then((response) => {
              if (response.results[0]) {
                position.address = response.results[0].formatted_address;
                loaderElm.style.display = "none";
                setData(position);
              } else {
                window.alert("${translate('No results found')}");
              }
            }).catch((e) => window.alert("${translate(
              'Geocoder failed due to: ',
            )}" + e));
          }

          function getLocationDetail(geocoder, pos, loaderElm) {
            loaderElm.style.display = "flex";
            const position = pos;
            geocoder.geocode({ location: position }).then((response) => {
              if (response.results[0]) {
                position.address = response.results[0].formatted_address;
                loaderElm.style.display = "none";
                setData(position);
              } else {
                window.alert("${translate('No results found')}");
              }
            }).catch((e) => window.alert("${translate(
              'Geocoder failed due to: ',
            )}" + e));
          }

          function setData(data) {
            var payloadStr = JSON.stringify(data);
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(payloadStr);
            } else {
              window.postMessage(payloadStr);
            }
          };
  
          var script = document.createElement('script');
          script.src = 'https://maps.googleapis.com/maps/api/js?key=${getGoogleMapKey()}&callback=initMap&v=weekly';
          script.async = true;
          document.head.appendChild(script);
  
        </script>
      </head>
       <body style="margin:0;padding:0;">
        <div id="map" style="width: 100vw; height: 100vh;"></div>
        <div id="spinner-container" style="display:none;"><div class="spinner"></div></div>
      </body>
      </html>
    `;
  }

  const showModal = (show = true) => {
    if (show === false) {
      if (props.value?.latitude && props.value?.latitude) {
        setLoc({
          latitude: props.value.latitude,
          longitude: props.value.longitude,
        });
      }
      if (form?.values?.street) {
        setPlace(form.values.street);
      }
      setModal(show);
      return;
    }
    setModalHtml('');
    setModal(show);
    setTimeout(() => {
      setModalHtml(
        getMapScript(
          {
            lat: loc?.latitude
              ? loc.latitude
              : currentLocation?.latitude
              ? currentLocation.latitude
              : '',
            lng: loc?.longitude
              ? loc.longitude
              : currentLocation?.longitude
              ? currentLocation.longitude
              : '',
          },
          false,
          14,
          currentLocation,
          true,
        ),
      );
    }, 500);
  };

  const generateAddress = (data) => {
    const res = data[0];
    const temp = {};
    for (let index = 0; index < res.address_components.length; index++) {
      const element = res.address_components[index];
      for (let index2 = 0; index2 < element.types.length; index2++) {
        const element2 = element.types[index2];
        temp[element2] = {
          long_name: element.long_name,
          short_name: element.short_name,
        };
      }
    }
    temp.full_address = res.formatted_address;
    return temp;
  };

  const getMapDetail = async (latLong) => {
    const reverse = await googleMapsGeocode({
      params: {
        filter: {
          latlng: latLong.latitude
            .toString()
            .concat(',', latLong.longitude.toString()),
        },
      },
    });
    if (reverse?.data?.data?.results?.length) {
      try {
        const temp = generateAddress(reverse.data.data.results);
        onChangeAddress({
          state: temp.administrative_area_level_1
            ? temp.administrative_area_level_1.long_name
            : '',
          city: temp.administrative_area_level_2
            ? temp.administrative_area_level_2.long_name
            : '',
          postal_code: temp.postal_code ? temp.postal_code.long_name : '',
          street: temp.full_address,
        });
      } catch (error) {}
    }
  };

  const onSubmit = async (location = null, picked = false) => {
    const newLocation = {
      latitude: location?.latitude ? location.latitude : loc.latitude,
      longitude: location?.longitude ? location.longitude : loc.longitude,
    };
    if (newLocation.latitude && newLocation.longitude) {
      await setHtml('');
      await setLocation({
        lat: newLocation.latitude,
        lng: newLocation.longitude,
      });
      onChange(newLocation);
      if (picked) {
        getMapDetail(newLocation);
      } else {
        setModal(false);
      }
    }
  };

  const mapClicked = async (type, pickValue = {}) => {
    if (type === 'current') {
      if (onCurrentLocation) {
        getReverse({
          lat: currentLocation.latitude,
          lng: currentLocation.longitude,
        }).then((response) => {
          if (response.status === 200) {
            const temp = generateAddress(response.data.data.results);
            onCurrentLocation({
              address: {
                postcode: temp.postal_code ? temp.postal_code.long_name : '',
                state: temp.administrative_area_level_1
                  ? temp.administrative_area_level_1.long_name
                  : '',
              },
              display_name: temp.full_address,
            });
          }
        });
      }
    } else if (type === 'address') {
      showModal();
      setPlace('');
    } else if (type === 'picked') {
      const latLong = {
        latitude: pickValue.latitude,
        longitude: pickValue.longitude,
      };
      setLoc(latLong);
      onSubmit(latLong, true);
      setPlace(pickValue.name || '');
      setModalHtml('');
      setTimeout(() => {
        setModalHtml(
          getMapScript(
            {
              lat: latLong.latitude,
              lng: latLong.longitude,
            },
            false,
            14,
            currentLocation,
            true,
          ),
        );
      }, 250);
    } else if (type === 'url') {
      Linking.openURL(generateGMapsLink(loc.latitude, loc.longitude));
    }
  };

  const setLocation = (location) => {
    if (location?.lat && location?.lng && !html) {
      setHtml(getMapScript(location, disabled, 16, currentLocation));
      setLoc({ latitude: location.lat, longitude: location.lng });
    }
  };

  const getReverse = async (payload, changeData = true) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const response = await googleMapsGeocode({
        params: {
          filter: {
            latlng: payload.lat.toString().concat(',', payload.lng.toString()),
          },
        },
      });
      if (changeData) {
        onChange({ latitude: payload.lat, longitude: payload.lng });
      } else {
        setLoc({ latitude: payload.lat, longitude: payload.lng });
      }
      if (response?.data?.data?.results?.length) {
        setPlace(response.data.data.results[0].formatted_address || '');
      }
      dispatch(showPopup({ name: 'isLoading', value: false }));
      return response;
    } catch (e) {
      console.log(e);
      dispatch(showPopup({ name: 'isLoading', value: false }));
      return false;
    }
  };

  const getLocation = async (data) => {
    setLoc('');
    if (typeof data.data !== 'string') {
      return false;
    }
    const location = JSON.parse(data.data);
    if (location.lat && location.lng) {
      setLoc({ latitude: location.lat, longitude: location.lng });
      setPlace(location.address || '');
    }
  };

  const onChangeSelect = async (value) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    await setPlace('');
    try {
      // Get lat long
      const res = await googleMapsPlaceDetail(value.id);
      if (res?.data?.data?.result) {
        const addressDetail = res?.data?.data?.result;
        mapClicked('picked', {
          latitude: addressDetail.geometry.location.lat,
          longitude: addressDetail.geometry.location.lng,
        });
        setTimeout(() => setPlace(value.name), 100);
      }
    } catch (error) {
      console.log('failed to get address', error);
    }
    dispatch(showPopup({ name: 'isLoading', value: false }));
  };

  useEffect(() => {
    let mounted = false;
    if (!mounted && currentLocation) {
      setNoLocation(false);
      if (form?.values?.street && !place) {
        setPlace(form?.values?.street);
      }
      if (props.value?.latitude && props.value?.longitude) {
        setLocation({
          lat: props.value.latitude,
          lng: props.value.longitude,
        });
      } else if (currentLocation?.latitude && currentLocation?.longitude) {
        setLocation({
          lat: currentLocation.latitude,
          lng: currentLocation.longitude,
        });
      } else {
        setNoLocation(true);
      }
    }
    return () => {
      mounted = true;
    };
  }, [currentLocation]);

  return (
    <View style={[formControlContainer, containerStyle]}>
      {label && (
        <FormLabel label={label} isRequired={Boolean(props.isRequired)} />
      )}
      {value ? (
        <View
          style={[
            styles.mapContainer,
            { height, top: label ? 35 : 7, alignItems: 'flex-start', left: 7 },
          ]}>
          {editable ? (
            <Button
              rounded={false}
              buttonStyle={{
                width: 30,
                height: 30,
                borderRadius: 4,
                backgroundColor: Colors.white,
                borderColor: Colors.white,
                shadowColor: Colors.black,
                shadowOffset: {
                  width: 0,
                  height: 1,
                },
                shadowOpacity: 0.65,
                shadowRadius: 5,
              }}
              title={
                <Image
                  style={{ width: 14, height: 14 }}
                  width={14}
                  height={14}
                  svg={true}
                  source={require('@assets/img/icons/edit-blue.svg')}
                />
              }
              onPress={() => showModal()}
            />
          ) : (
            <TouchableOpacity
              style={{ height: '100%', width: '100%' }}
              onPress={() => mapClicked('url')}>
              <View />
            </TouchableOpacity>
          )}
        </View>
      ) : (
        <View
          style={[
            styles.mapContainer,
            styles.overlayBackground,
            {
              height,
              top: label ? 28 : 0,
              alignItems: 'center',
              justifyContent: 'center',
            },
          ]}>
          {loading ? (
            <>
              <SociollaText
                type="medium"
                style={{ fontSize: 12, color: Colors.grey13 }}>
                finding location...
              </SociollaText>
              <ActivityIndicator
                size="small"
                color={Colors.blue0}
                style={{ marginTop: 30 }}
              />
            </>
          ) : (
            <>
              <View style={{ flexDirection: 'row', marginBottom: 20 }}>
                <Image
                  style={{ width: 14, height: 14 }}
                  width={14}
                  height={14}
                  svg={true}
                  source={require('@assets/img/icons/attention-red.svg')}
                />
                <SociollaText
                  style={{ marginLeft: 8, fontSize: 12, color: Colors.red3 }}>
                  Address pinpoint not set
                </SociollaText>
              </View>
              <Button
                rounded={true}
                buttonStyle={{ width: 200 }}
                title="Use current location"
                disabled={!currentLocation}
                disabledStyle={{ width: 200 }}
                onPress={() => mapClicked('current')}
              />
              <SociollaText
                style={{ fontSize: 10, marginTop: 5, color: Colors.red3 }}>
                *please enable location permission
              </SociollaText>
              {form && form.values && (
                <Button
                  rounded={true}
                  buttonStyle={{
                    width: 200,
                    marginTop: 10,
                  }}
                  title="Find by street address"
                  onPress={() => mapClicked('address')}
                />
              )}
            </>
          )}
        </View>
      )}
      <View style={{ height, marginBottom: 10, zIndex: -1, borderRadius: 4 }}>
        {isNative ? (
          html ? (
            <WebViews
              ref={webViewRef}
              originWhitelist={['*']}
              source={{ html, baseUrl: getMapWebViewBaseUrl() }}
              javaScriptEnabled={true}
              domStorageEnabled={true}
              startInLoadingState={true}
              style={{ height, flex: 1 }}
              onMessage={getLocation}
              androidHardwareAccelerationDisabled={true}
            />
          ) : noLocation ? (
            <SociollaText>Cannot load Google Maps correctly</SociollaText>
          ) : (
            <Loader />
          )
        ) : (
          <div id="nina-google-maps" style={{ height, flex: 1 }}></div>
        )}
      </View>
      {!hideInput && (
        <View style={{ width: '100%' }}>
          <SelectBox
            label="Find Address"
            hideLabel={true}
            options={[]}
            value={place}
            trackBy="id"
            labelKey="name"
            placeholder="Telusuri Google Maps"
            isMap="google"
            mapApi={googleMapsAutocomplete}
            buttonAction={true}
            style={{ width: '100%' }}
            onChange={onChangeSelect}
          />
        </View>
      )}
      {modal && (
        <ModalFull
          show={modal}
          title="Set Location"
          width={isWeb ? 650 : '100%'}
          onClose={() => showModal(false)}>
          <View
            style={{
              height: isWeb ? 500 : screenHeight - 200,
              marginBottom: 10,
              borderRadius: 4,
            }}>
            {isNative ? (
              modalHtml ? (
                <WebViews
                  originWhitelist={['*']}
                  source={{ html: modalHtml, baseUrl: getMapWebViewBaseUrl() }}
                  javaScriptEnabled={true}
                  domStorageEnabled={true}
                  startInLoadingState={true}
                  style={{ height: isWeb ? 500 : screenHeight - 200 }}
                  onMessage={getLocation}
                  onClick={mapClicked}
                />
              ) : (
                <Loader />
              )
            ) : (
              <div
                id="nina-google-maps-modal"
                style={{ height: isWeb ? 500 : screenHeight - 200 }}></div>
            )}
          </View>
          <View style={{ paddingHorizontal: 20, alignItems: 'center' }}>
            <View style={{ width: '100%' }}>
              <SelectBox
                label="Find Address"
                hideLabel={true}
                options={[]}
                value={place}
                trackBy="id"
                labelKey="name"
                placeholder="Telusuri Google Maps"
                isMap="google"
                mapApi={googleMapsAutocomplete}
                buttonAction={true}
                style={{ width: '100%' }}
                onChange={onChangeSelect}
              />
            </View>
            <View
              style={[
                isWeb ? { marginTop: 20, flex: 1 } : buttonFloating,
                isWeb
                  ? { justifyContent: 'center', width: 200, marginBottom: 20 }
                  : {
                      position: 'relative',
                      elevation: 0,
                      marginTop: 20,
                      width: '100%',
                    },
                { bottom: 0 },
              ]}>
              <Button
                buttonStyle={{ ...buttonRounded, width: '100%' }}
                disabledStyle={{ ...buttonRounded, width: '100%' }}
                disabled={!place}
                title={
                  <SociollaText
                    type="bold"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.white,
                      width: '100%',
                      textAlign: 'center',
                    }}>
                    Submit
                  </SociollaText>
                }
                onPress={onSubmit}
              />
            </View>
          </View>
        </ModalFull>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  mapContainer: {
    zIndex: 99,
    position: 'absolute',
    width: '100%',
    borderRadius: 4,
  },
  overlayBackground: {
    backgroundColor: Colors.grey12,
  },
});

export default SociollaGoogleMaps;
